module.exports = __webpack_public_path__ + "img/KarimKaka-Shingal.73272776.jpg";